import React from 'react';
import { withStyles } from "tss-react/mui";
import { connect } from 'react-redux';
import AppView from 'areas/shell/components/AppView';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import QRCodeReaderDialog from 'components/QRCodeReaderDialog';
import QRCodeScannerDialog from 'components/QRCodeScannerDialog';
import ManualLookupDialog from 'areas/cardLookup/components/ManualLookupDialog';
import CardHolderView from 'areas/cards/components/CardHolderView';
import VisitorPassView from 'areas/visitorpass/components/VisitorPassView';
import SpotCheckList from 'areas/swipes/components/SpotCheckList';
import { uploadSwipe } from 'areas/swipes/actions';
import visitorPassActions from 'areas/visitorpass/actions';
import SpotCheckMonoIcon from 'components/Icons/SpotCheck/SpotCheckMono';
import AuthChooseButton from 'components/AuthChooserButton';
import { getCardCheckerCard, getCurrentCard } from 'areas/cards/selectors';
import { getCurrentVisitorPass } from 'areas/visitorpass/selectors';
import { activeSwipes } from 'areas/swipes/selectors';
import alertActions from 'areas/alert/actions';
import {
    hideCardholderPage,
    receiveVisitorPass,
    showVisitorPassPage,
    hideVisitorPassPage
} from 'areas/cards/actions';
import {
    showManualLookupDialog,
    hideManualLookupDialog,
    byQRCode,
    byLookup
} from 'areas/cardLookup/actions';
import SwipeEngine from 'areas/swipes/domain/swipeEngine';
import VisitorPassEngine from 'areas/visitorpass/domain/visitorPassEngine';
import styles from './styles';
import m from 'messages';
import isStringSet from 'utilities/is/isStringSet';
import displayMode from 'areas/swipes/domain/displayMode';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { appInsightsService } from "utilities/logging/appInsightsService";
import logService, { removeFields } from 'utilities/logging/logService';

class SpotCheckPage extends React.Component {

    constructor(props) {
        super(props);
        this.swipeEngine = new SwipeEngine();
        this.visitorEngine = new VisitorPassEngine();
        this.state = {
            qrCodeDialogOpen: false,
            qrScannerDialogOpen: false
        };
    }

    onOkSpotCheckClicked = () => {
        const { location, card, pass, cardCheckerCard } = this.props;

        let swipe = null;

        if (card) {
            swipe = this.swipeEngine.spotCheck(card, location, cardCheckerCard);
            const result = this.swipeEngine.validateSwipeIn(card);

            // The deny reason and description are not actually sent with the spot check, but the
            // app needs a way of keeping track of what alert is shown in the UI for the spot check
            // when this gets reopened from the swipe list
            if (result && isStringSet(result.reasonID)) {

                // The deny reason is for display only for spot checks, so do not store the denyReasonID
                // on the swipe as this will cause the deny reason to be sent to the server which is not
                // required for spot checks
                swipe.denyReasonDescription = result.reasonDescription;
            }
        }
        else {
            swipe = this.swipeEngine.spotCheckVisitorPass(pass, location, cardCheckerCard);
        }

        this.closeCardholderView();
        logService.info('spot check', { swipe: removeFields(swipe), card: removeFields(card) });
        setTimeout(() => this.props.uploadSwipe(swipe), 200);
    };

    closeQrDialog = () => {
        this.setState({ qrCodeDialogOpen: false, qrScannerDialogOpen: false });
    };

    closeManualLookupDialog = () => {
        this.props.hideManualLookupDialog();
    };

    closeCardholderView = () => {
        this.props.hideCardholderPage();
    };

    closeVisitorPassView = () => {
        this.props.hideVisitorPassPage();
    };

    handleScan = (qrCode) => {
        const { location } = this.props;

        this.closeQrDialog();
        setTimeout(() => this.props.lookupByQrCode(qrCode, location), 0);
    };

    handleVisitorPassScan = (qrCode) => {
        const { passes } = this.props;
        const pass = passes && passes[qrCode];

        if (pass) {
            // Signal the card data has been received
            this.props.receiveVisitorPass(qrCode, pass);
            this.props.showVisitorPassPage(qrCode);
        } else {
            this.props.lookupVisitorByQrCode(qrCode);
        }

        this.closeQrDialog();
    };

    handleManualLookup = (formData) => {
        this.props.lookupByFormInput(formData);
    };

    qrCodeClicked = () => {
        setTimeout(() => {
            this.setState({ qrCodeDialogOpen: true });
        }, 500);
    };

    qrScannerClicked = () => {
        this.setState({ qrScannerDialogOpen: true });
    };

    forgottenCardClicked = () => {
        setTimeout(() => {
            this.props.showManualLookupDialog();
        }, 500);
    };

    onScanError = (message) => {
        this.props.alert(message);
    };

    qrReaderDialog = () => {
        return (
            <QRCodeReaderDialog
                title={m.scan.scanQrCodeTitle}
                open={this.state.qrCodeDialogOpen}
                handleClose={this.closeQrDialog}
                onCardScanned={this.handleScan}
                onScanError={this.onScanError}
                onVisitorPassScanned={this.handleVisitorPassScan}
                config={this.props.config}
            />
        );
    };

    qrScannerDialog = () => {
        return (
            <QRCodeScannerDialog
                title={m.scan.scanQrCodeTitle}
                open={this.state.qrScannerDialogOpen}
                handleClose={this.closeQrDialog}
                onCardScanned={this.handleScan}
                onScanError={this.onScanError}
                onVisitorPassScanned={this.handleVisitorPassScan}
                config={this.props.config}
            />
        );
    };

    manualLookupDialog = () => {
        return (
            <ManualLookupDialog
                open={!this.props.hasAlert && !!this.props.shouldShowManualLookupDialog}
                handleClose={this.closeManualLookupDialog}
                cardNumberLabel={this.props.config.productNumberName}
                onSubmit={this.handleManualLookup} />
        );
    };

    spotCheckList() {
        const { swipes, classes, config, location, supervisorData } = this.props;

        return (
            <div className={classes.listPanel}>
                <SpotCheckList
                    config={config}
                    location={location}
                    supervisorData={supervisorData}
                    swipes={swipes} />
            </div>
        );
    }

    visitorPassView = () => {
        const { cardConfig, pass, config } = this.props;
        const { showVisitorPassPage } = cardConfig;

        const isOpen = pass && showVisitorPassPage;
        const engineStatus = pass && this.visitorEngine.getVisitorPassStatus(pass);

        return (
            <React.Fragment>
                {isOpen &&
                    <VisitorPassView
                        pass={pass.pass}
                        status={engineStatus}
                        config={config}
                        close={this.closeVisitorPassView}
                        disableBackButton={true}
                        title={m.visitorPass._self}
                        open={true}>
                        <PrimaryDialogButton onClick={this.onOkSpotCheckClicked}>OK</PrimaryDialogButton>
                    </VisitorPassView>
                }
            </React.Fragment>
        );

    };

    cardHolderView = () => {
        const { cardConfig, card, config, location } = this.props;
        const { showCardholderPage } = cardConfig;

        if (!card || !showCardholderPage) {
            return (<div></div>);
        }

        const result = this.swipeEngine.validateSwipeIn(card);
        const denyReason = (result && isStringSet(result.reasonDescription)) ? result : null;

        return (
            <CardHolderView
                card={card}
                config={config}
                location={location}
                close={this.closeCardholderView}
                title={`${card.firstname} ${card.surname}`}
                disableBackButton={true}
                denyReason={denyReason}
                viewcontext={displayMode.spotCheck}
                open={true}>
                <PrimaryDialogButton onClick={this.onOkSpotCheckClicked}>OK</PrimaryDialogButton>
            </CardHolderView>);
    };

    fabButtons() {
        return (
            <AuthChooseButton
                icon={SpotCheckMonoIcon}
                text={m.spotCheck._self}
                handleClose={this.handleAuthSelectorClose}
                qrCodeClicked={this.qrCodeClicked}
                qrScannerClicked={this.qrScannerClicked}
                forgottenCardClicked={this.forgottenCardClicked} />
        );
    }

    render() {
        const { classes, pageTitle } = this.props;

        return (
            <div>
                <AppView title={pageTitle} className={classes.pageContainer}>
                    {this.spotCheckList()}
                    {this.cardHolderView()}
                    {this.visitorPassView()}
                    {this.qrReaderDialog()}
                    {this.qrScannerDialog()}
                    {this.manualLookupDialog()}
                    {this.fabButtons()}
                </AppView>
            </div>
        );
    }
}

function mapStateToProps(state) {

    const {
        alert,
        cards,
        config,
        data,
        location,
        supervisor
    } = state;

    const processedCardCheckerCard = getCardCheckerCard(state);
    const processedPass = getCurrentVisitorPass(state);
    const processedCard = getCurrentCard(state);

    return {
        ...supervisor,

        supervisorData: supervisor,

        hasAlert: alert.message && alert.message.length > 0,

        cardConfig: cards,

        // the map of QR -> card data
        cards: cards.cards,

        // The current card being viewed
        card: processedCard,

        // The map of QR -> visitor passes
        passes: cards.passes,

        // The current visitor pass being viewed
        pass: processedPass,

        // The card information for the logged in card checker
        cardCheckerCard: processedCardCheckerCard,

        // The array of historic swipes
        swipes: activeSwipes(state),

        // Should the manual lookup dialog be rendered?
        shouldShowManualLookupDialog: data.showManualLookupDialog,
        config,
        location
    };
}

function mapDispatchToProps(dispatch) {
    return {
        alert: (message, callback) => dispatch(alertActions.error(message, callback)),
        uploadSwipe: (swipe) => dispatch(uploadSwipe(swipe)),
        showManualLookupDialog: () => dispatch(showManualLookupDialog()),
        hideManualLookupDialog: () => dispatch(hideManualLookupDialog()),
        hideCardholderPage: () => dispatch(hideCardholderPage()),
        hideVisitorPassPage: () => dispatch(hideVisitorPassPage()),
        lookupByQrCode: (qrCode, location) => dispatch(byQRCode(qrCode, location)),
        lookupByFormInput: (formData) => dispatch(byLookup(
            formData.surname,
            formData.initial,
            (formData.dob ? formData.dob.toISODate() : ''),
            formData.cardNumber)),
        lookupVisitorByQrCode: (qrCode) => dispatch(visitorPassActions.byQRCode(qrCode)),
        receiveVisitorPass: (qrCode, pass) => dispatch(receiveVisitorPass(qrCode, pass)),
        showVisitorPassPage: (qrCode) => dispatch(showVisitorPassPage(qrCode))
    };
}

const styledPage = withStyles(SpotCheckPage, styles);
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(styledPage);

export default withAITracking(appInsightsService.reactPlugin, connectedPage, "Spot Check Page", "SpotCheckPage");